export default __webpack_public_path__ + "static/media/Halcyon-Logo-Stacked-BlackCyan.f9c62c0b.png";